import { render, staticRenderFns } from "./TheTechSection.vue?vue&type=template&id=019f9c10&scoped=true&"
import script from "./TheTechSection.vue?vue&type=script&lang=ts&"
export * from "./TheTechSection.vue?vue&type=script&lang=ts&"
import style0 from "./TheTechSection.vue?vue&type=style&index=0&id=019f9c10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019f9c10",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default,FCSwiper: require('/opt/build/repo/apps/shop/components/FCSwiper.vue').default})
